export enum ProductMapping {
  "Internet" = "Broadband",
  "Voice" = "Telephony",
}

export enum ProductName {
  "Internet" = "Internet",
  "Voice" = "Voice",
}
